export default __webpack_public_path__ + "static/img-9-e848443cf37280ffaaf2e7a3d888768a.jpg";